import { useLazyQuery } from "@apollo/client/react";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Card,
  Chip,
  Grid,
  TextField
} from '@mui/material';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { adaptCriterioArray } from '../../../../adapters/criterioAdapter';
import { adaptFaseArray } from '../../../../adapters/faseAdapters';
import { adaptFiguraProfesionalByIdArray } from '../../../../adapters/figuraProfesionalAdapter';
import { adaptFrecuenciaProfesionalArray } from '../../../../adapters/frecuenciaProfesionalAdapter';
import { adaptModalidadProfesionalCobroArray } from '../../../../adapters/modalidadProfesionalCobro';
import { adaptModalidadVisitaArray } from '../../../../adapters/modalidadVisitaAdapter';
import { adaptPlanCuidadoDuracionFaseArray } from '../../../../adapters/planCuidadoDuracionFase';
import { adaptTipoProfesionalArray } from '../../../../adapters/tipoProfesionalAdapter';
import EmptyGridSvg from '../../../../assets/svg/EmptyGridInsumo.svg';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import { GET_ALL_CRITERIOS } from '../../../../data/graphQL/queries/PlanCuidado/getCriterios';
import { GET_ALL_FASES } from '../../../../data/graphQL/queries/PlanCuidado/getFases';
import { GET_ALL_FIGURA_PROFESIONAL } from '../../../../data/graphQL/queries/PlanCuidado/getFiguraProfesionales';
import { GET_ALL_FRECUENCIA_PROFESIONALES } from '../../../../data/graphQL/queries/PlanCuidado/getFrecuenciaProfesional';
import { GET_ALL_MODALIDAD_PROFESIONAL_COBRO } from '../../../../data/graphQL/queries/PlanCuidado/getModalidadProfesionalCobro';
import { GET_ALL_MODALIDAD_VISITA } from '../../../../data/graphQL/queries/PlanCuidado/getModalidadVisita';
import { GET_ALL_PLAN_CUIDADO_DURACION_FASE } from '../../../../data/graphQL/queries/PlanCuidado/getPlanCuidadoDuracionFase';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import './stepProfesionales.scss';

const idTipoProfesionalMedico = 1;
const idTipoProfesionalNutricionista = 3;
const idTipoProfesionalFonoaudiologo = 4;
const idMedicoConsultor = 2;
const idMedicoEspecialista = 4;
const idNutricionistaConsultor = 37;
const idNutricionistaEspecialista = 38;
const idFonoaudiologoConsultor = 39;
const idFonoaudiologoEspecialista = 40;

const tiposProfesionalPermitidos = [
  idTipoProfesionalMedico,
  idTipoProfesionalNutricionista,
  idTipoProfesionalFonoaudiologo
];

const tiposFigurasPermitidos = [
  idMedicoConsultor,
  idMedicoEspecialista,
  idNutricionistaConsultor,
  idNutricionistaEspecialista,
  idFonoaudiologoConsultor,
  idFonoaudiologoEspecialista
];


const ensureRowId = (obj) => {
  if (obj?.idPlanCuidadoFaseProfesional > 0) return obj;
  if (!obj?._rowId) {
    const fallback = `tmp_${Date.now()}_${Math.random()}`;
    const tmp = typeof crypto !== "undefined" && crypto.randomUUID ?
      crypto.randomUUID() :
      fallback;

    return { ...obj, _rowId: tmp };
  }
  return obj;
};

const getRowId = (obj) =>
  obj?.idPlanCuidadoFaseProfesional || obj?._rowId || null;

const StepProfesionales = ({ stepsData, setStepsData }) => {
  const ordenes = [
    { id: 1, displayName: "1", name: "1" },
    { id: 2, displayName: "2", name: "2" },
    { id: 3, displayName: "3", name: "3" },
    { id: 4, displayName: "4", name: "4" },
    { id: 5, displayName: "5", name: "5" }];


  const initialDatosFases = {
    idPlanCuidado: stepsData?.datosGenerales?.idPlanCuidado,
    idFase: 0,
    idPlanCuidadoFase: 0,
    idPlanCuidadoDuracionFase: 0,
    planCuidadoFaseCriterio: []
  };

  const initialDatosProfesionales = {
    idPlanCuidado: stepsData?.datosGenerales?.idPlanCuidado,
    idPlanCuidadoFase: 0,
    idPlanCuidadoFaseProfesional: 0,
    idTipoProfesional: 0,
    idFiguraProfesional: null,
    idModalidadVisita: 0,
    idModalidadProfesionalCobro: 0,
    idFrecuenciaProfesional: 0,
    orden: 0,
    duracion: 0
  };

  const figurasMedicos = ['Seguimiento', 'Consultor', 'Especialista'];
  const [openModalFase, setOpenModalFase] = useState(false);
  const [openModalProfesional, setOpenModalProfesional] = useState(false);
  //datosProfesionales son los datos del profesional que se está creando/editando en una fase
  const [datosProfesionales, setDatosProfesionales] = useState(initialDatosProfesionales);
  const [datosFases, setDatosFases] = useState(initialDatosFases);
  const [editionMode, setEditionMode] = useState();
  const [getTipoProfesionales, { loading: tipoProfesionalesLoading, data: tipoProfesionalesData }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoProfesionalesData) return;
    setTipoProfesionales(adaptTipoProfesionalArray(tipoProfesionalesData));
  }, [tipoProfesionalesData])

  const [getFiguraProfesionales, { loading: figuraProfesionalesLoading, data: figuraProfesionalesData }] = useLazyQuery(GET_ALL_FIGURA_PROFESIONAL, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!figuraProfesionalesData) return;
    if (tiposProfesionalPermitidos.includes(datosProfesionales?.idTipoProfesional))
      setFiguraProfesionales(adaptFiguraProfesionalByIdArray(figuraProfesionalesData).filter(x => figurasMedicos.includes(x.displayName)))
    else
      setFiguraProfesionales(adaptFiguraProfesionalByIdArray(figuraProfesionalesData).filter(x => x.displayName == 'Seguimiento'))
  }, [figuraProfesionalesData])


  const [getFiguraProfesionalesAll, { loading: figuraProfesionalesALLLoading, data: figuraProfesionalesALLData }] = useLazyQuery(GET_ALL_FIGURA_PROFESIONAL, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!figuraProfesionalesALLData) return;
    setFiguraProfesionalesAll(adaptFiguraProfesionalByIdArray(figuraProfesionalesALLData));
  }, [figuraProfesionalesALLData])


  const [getModalidadVisitas, { loading: modalidadVisitasLoading, data: modalidadVisitasData }] = useLazyQuery(GET_ALL_MODALIDAD_VISITA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!modalidadVisitasData) return;
    setModalidadVisitas(adaptModalidadVisitaArray(modalidadVisitasData));
  }, [modalidadVisitasData])

  const [getModalidadProfesionalCobro, { loading: modalidadProfesionalLoading, data: modalidadProfesionalData }] = useLazyQuery(GET_ALL_MODALIDAD_PROFESIONAL_COBRO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!modalidadProfesionalData) return;
    setModalidadProfesionalCobro(adaptModalidadProfesionalCobroArray(modalidadProfesionalData));
  }, [modalidadProfesionalData])

  const [getFrecuenciaProfesionales, { loading: frecuenciaProfesionalesLoading, data: frecuenciaProfesionalesData }] = useLazyQuery(GET_ALL_FRECUENCIA_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!frecuenciaProfesionalesData) return;
    setAllFrecuenciaProfesionales(adaptFrecuenciaProfesionalArray(frecuenciaProfesionalesData));
    if (tiposFigurasPermitidos.includes(datosProfesionales?.idFiguraProfesional))
      setFrecuenciaProfesionales(adaptFrecuenciaProfesionalArray(frecuenciaProfesionalesData).filter(x => x.displayName == 'Ninguna'));
    else
      setFrecuenciaProfesionales(adaptFrecuenciaProfesionalArray(frecuenciaProfesionalesData).filter(x => x.displayName != 'Ninguna'));
  }, [frecuenciaProfesionalesData])


  const [getCriterios, { loading: criteriosLoading, data: criteriosData }] = useLazyQuery(GET_ALL_CRITERIOS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!criteriosData) return;
    setCriterios(adaptCriterioArray(criteriosData));
  }, [criteriosData])

  const [getFases, { loading: fasesLoading, data: fasesData }] = useLazyQuery(GET_ALL_FASES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!fasesData) return;
    setFases(adaptFaseArray(fasesData));
  }, [fasesData])

  const [getDuracion, { loading: duracionLoading, data: duracionData }] = useLazyQuery(GET_ALL_PLAN_CUIDADO_DURACION_FASE, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!duracionData) return;
    setDuracion(adaptPlanCuidadoDuracionFaseArray(duracionData));
  }, [duracionData])

  const [tipoProfesionales, setTipoProfesionales] = useState([]);
  const [figuraProfesionales, setFiguraProfesionales] = useState([]);
  const [figuraProfesionalesAll, setFiguraProfesionalesAll] = useState([]);
  const [modalidadVisitas, setModalidadVisitas] = useState([]);
  const [modalidadProfesionalCobro, setModalidadProfesionalCobro] = useState([]);
  const [allFrecuenciaProfesionales, setAllFrecuenciaProfesionales] = useState([]);
  const [frecuenciaProfesionales, setFrecuenciaProfesionales] = useState([]);
  const [criterios, setCriterios] = useState([]);
  const [fases, setFases] = useState([]);
  const [duracion, setDuracion] = useState([]);
  const [fasesCreada, setFasesCreada] = useState([]);
  const [habilitarDuracion, setHabilitarDuracion] = useState(false);

  const initialColumns = [
    {
      field: 'idTipoProfesional',
      headerName: 'Tipo de profesional',
      valueGetter: (idTipoProfesional) => {
        return tipoProfesionales?.find((tp) => tp.id === idTipoProfesional)?.displayName;
      }
    },
    {
      field: 'idFiguraProfesional',
      headerName: 'Responsabilidad',
      valueGetter: (idFiguraProfesional) => {
        return figuraProfesionalesAll?.find((tp) => tp.id === idFiguraProfesional)?.displayName;
      }
    },
    {
      field: 'idModalidadProfesionalCobro',
      headerName: 'Modalidad',
      valueGetter: (idModalidadProfesionalCobro) => {
        return modalidadProfesionalCobro?.find((tp) => tp.id === idModalidadProfesionalCobro)?.displayName;
      }
    },
    {
      field: 'idFrecuenciaProfesional',
      headerName: 'Frecuencia',
      valueGetter: (idFrecuenciaProfesional) => {
        return allFrecuenciaProfesionales?.find((tp) => tp.id === idFrecuenciaProfesional)?.displayName;
      }
    },
    {
      field: 'orden',
      headerName: 'Orden'
    },
    {
      field: 'duracion',
      headerName: 'Duración',
      valueGetter: (duracionValue) => {
        //Si la duracion es 0, en vez de obtener el valor por id, se obtiene por la "duration" que también es 0
        return duracion?.find((tp) => tp[duracionValue === 0 ? 'duration' : 'id'] === duracionValue)?.displayName;
      }
    },
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <PopoverModal>
            <div className='popover-modal-content'>
              <div className='item-option clickable-option'
                aria-hidden='true'
                onClick={() => {
                  const { id, ...props } = row;
                  const withId = ensureRowId(props); // asegura _rowId si no hay id de DB
                  const formCopy = structuredClone(withId);
                  getFiguraProfesionales({ variables: { idTipoProfesional: formCopy?.idTipoProfesional } });
                  setDatosProfesionales(formCopy);
                  setEditionMode(formCopy);
                  setOpenModalProfesional(true);
                }}>

                <EditIcon className='edit-icon' />
                <span className='toggle-action'>Editar</span>
              </div>
              <div className='item-option clickable-option'
                aria-hidden='true'
                onClick={() => {
                  setStepsData((previousData) => ({
                    ...previousData,
                    profesionales: previousData.profesionales.filter(
                      (p) => getRowId(p) !== getRowId(row)
                    )
                  }));
                }}>

                <DeleteIcon className='edit-icon' />
                <span className='toggle-action'>Eliminar</span>
              </div>
            </div>
          </PopoverModal>);

      }
    }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  useEffect(() => {
    getFiguraProfesionalesAll(
      {
        variables: {
          idTipoProfesional: 0
        }
      }
    );
  }, []);

  useEffect(() => {
    if (!modalidadProfesionalLoading) {
      getModalidadProfesionalCobro();
    }
    if (!tipoProfesionalesLoading) {
      getTipoProfesionales();
    }

    if (!modalidadVisitasLoading) {
      getModalidadVisitas();
    }

    if (!frecuenciaProfesionalesLoading) {
      getFrecuenciaProfesionales();
    }

    if (!criteriosLoading) {
      getCriterios();
    }

    if (!fasesLoading) {
      getFases();
    }

    if (!duracionLoading) {
      getDuracion();
    }
  }, []);

  const handleChange = (e) => {
    const { value, name } = e.target;

    setDatosProfesionales({
      ...datosProfesionales,
      [name]: value
    });

    limpiarCombos(e);
  };

  const handleChangeFase = (e) => {
    const { value, name } = e.target;

    setDatosFases((oldData) => ({
      ...oldData,
      [name]: value
    }));
  };

  const handleChangeCriterio = (e) => {
    const { value } = e.target;
    setDatosFases((previousData) => ({
      ...previousData,
      planCuidadoFaseCriterio: value
    }));
  };

  const handleCrearFase = () => {
    if (isValidFase()) {
      if (!stepsData?.fases?.find((f) => f.idFase === datosFases?.idFase) || editionMode) {
        const fase = fases.find((x) => x.id === datosFases?.idFase);

        if (!editionMode) {
          setFasesCreada([...fasesCreada, {
            id: fase.id,
            name: fase.name,
            displayName: fase.displayName,
            idPlanCuidadoDuracionFase: datosFases?.idPlanCuidadoDuracionFase
          }]);
        }

        setStepsData((previousData) => ({
          ...previousData,
          fases: editionMode ?
            [...(previousData.fases || []).filter((previousFase) => previousFase.idFase !== fase.id), datosFases] :
            [...(previousData.fases || []), {
              idFase: fase.id,
              idPlanCuidado: stepsData?.datosGenerales?.idPlanCuidado,
              idPlanCuidadoFase: 0,
              idPlanCuidadoDuracionFase: datosFases?.idPlanCuidadoDuracionFase,
              planCuidadoFaseCriterio: datosFases?.planCuidadoFaseCriterio
            }]
        }));

        setDatosFases(initialDatosFases);
        setEditionMode(undefined);
        setOpenModalFase(false);
      }
    }

  };

  const isValidFase = () => {
    if (datosFases.idFase <= 0) {
      toast.error('Debe seleccionar una fase.');
      return false;
    }
    if (datosFases.idPlanCuidadoDuracionFase <= 0) {
      toast.error('Debe seleccionar una duración.');
      return false;
    }
    return true;
  };

  const isValidFaseProfesional = () => {
    if (stepsData?.profesionales?.find(x => x.idPlanCuidadoFaseProfesional != datosProfesionales?.idPlanCuidadoFaseProfesional
      && x.idTipoProfesional == datosProfesionales?.idTipoProfesional
      && x.idFiguraProfesional == datosProfesionales?.idFiguraProfesional
      && x.idModalidadProfesionalCobro == datosProfesionales?.idModalidadProfesionalCobro
      && x.orden == datosProfesionales?.orden)) {
      toast.error('Ya existe un profesional ingresado con las mismas caracteristicas.');
      return false;
    }

    if (datosProfesionales.idTipoProfesional <= 0) {
      toast.error('Debe seleccionar un Tipo de Profesional.');
      return false;
    }

    if (datosProfesionales.idFiguraProfesional <= 0) {
      toast.error('Debe seleccionar una Responsabilidad.');
      return false;
    }

    if (datosProfesionales.idModalidadVisita <= 0) {
      toast.error('Debe seleccionar un Modo.');
      return false;
    }

    console.log(datosProfesionales.idFrecuenciaProfesional)
    if (!tiposFigurasPermitidos.includes(datosProfesionales?.idFiguraProfesional) && datosProfesionales.idFrecuenciaProfesional <= 0) {
      toast.error('Debe seleccionar una Frecuencia.');
      return false;
    }

    if (datosProfesionales.orden <= 0) {
      toast.error('Debe seleccionar un Orden.');
      return false;
    }

    if (datosProfesionales.idModalidadProfesionalCobro <= 0) {
      toast.error('Debe seleccionar una Modalidad de visita.');
      return false;
    }

    return true;
  }


  const handleAdicionarProfesional = () => {
    if (isValidFaseProfesional()) {
      const profesionalObject = {
        idPlanCuidadoFase: datosProfesionales?.idPlanCuidadoFase,
        idPlanCuidadoFaseProfesional: datosProfesionales.idPlanCuidadoFaseProfesional,
        idTipoProfesional: datosProfesionales.idTipoProfesional,
        idFiguraProfesional: datosProfesionales.idFiguraProfesional,
        idModalidadVisita: datosProfesionales.idModalidadVisita,
        idModalidadProfesionalCobro: datosProfesionales.idModalidadProfesionalCobro,
        idFrecuenciaProfesional: datosProfesionales.idFrecuenciaProfesional,
        orden: datosProfesionales.orden,
        duracion: datosProfesionales.duracion
      };

      if (datosProfesionales?.idPlanCuidadoFaseProfesional)
        profesionalObject.idPlanCuidadoFaseProfesional = datosProfesionales?.idPlanCuidadoFaseProfesional;

      const isEqualProfesional = (objectToCheck, propToCheck, objectToCompare = profesionalObject) => {
        return objectToCheck[propToCheck] === objectToCompare[propToCheck];
      };

      const checkExistantProfessional = (prof, profToCompare = undefined) => {
        return (
          isEqualProfesional(prof, 'idPlanCuidadoFase', profToCompare) &&
          isEqualProfesional(prof, 'idTipoProfesional', profToCompare) &&
          isEqualProfesional(prof, 'idTipoProfesionalEspecialidad', profToCompare) &&
          isEqualProfesional(prof, 'idPlanCuidadoFaseProfesional', profToCompare)
          // &&
          // isEqualProfesional(prof, 'idModalidadVisita', profToCompare)
          // isEqualProfesional(prof, 'idGrupoProfesional', profToCompare)
        );
      };

      const isValidDuracion = () => {
        //Valido que la sumatoria de la duracion de profesionales no sea mayor a la duracion de la fase
        let duracionSumattion = duracion?.find((obj) => obj.id == profesionalObject.duracion)?.duration;
        const idPlanCuidadoDuracionFase = stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase == datosProfesionales?.idPlanCuidadoFase || fase?.idFase == datosProfesionales?.idPlanCuidadoFase)?.idPlanCuidadoDuracionFase;
        const faseDurationSelected = duracion?.find((obj) => obj.id == idPlanCuidadoDuracionFase).duration;

        stepsData.profesionales.forEach((prof) => {
          if (stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase == prof?.idPlanCuidadoFase || fase?.idFase == prof?.idPlanCuidadoFase)?.idFase == stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase == profesionalObject?.idPlanCuidadoFase || fase?.idFase == profesionalObject?.idPlanCuidadoFase)?.idFase &&
            isEqualProfesional(prof, 'idTipoProfesional', profesionalObject) &&
            isEqualProfesional(prof, 'idTipoProfesionalEspecialidad', profesionalObject) &&
            !isEqualProfesional(prof, 'orden', profesionalObject))
            duracionSumattion += duracion?.find((obj) => obj.id == prof.duracion)?.duration;
        });

        return idPlanCuidadoDuracionFase == 1 || duracionSumattion <= faseDurationSelected;
      };

      const profWithId = ensureRowId(profesionalObject);
      const editionRowId = editionMode ? getRowId(editionMode) : null;
      const currentRowId = getRowId(profWithId);

      // const savedProfessionalExists = stepsData?.profesionales?.some((prof) => {
      //   const rowId = getRowId(prof);

      //   if (rowId && (rowId === editionRowId || rowId === currentRowId)) return false;

      //   return (
      //     checkExistantProfessional(prof) &&
      //     datosFases.idPlanCuidadoDuracionFase > 1 &&
      //     isEqualProfesional(prof, 'orden', profWithId) ||
      //     checkExistantProfessional(prof) &&
      //     datosFases.idPlanCuidadoDuracionFase === 1 &&
      //     isEqualProfesional(prof, 'idModalidadVisita', profWithId) &&
      //     isEqualProfesional(prof, 'idModalidadProfesionalCobro', profWithId));

      // });

      // const savedProfessionalExists = stepsData?.profesionales?.some(prof =>
      //     (checkExistantProfessional(prof) &&
      //         datosFases.idPlanCuidadoDuracionFase > 1 &&
      //         isEqualProfesional(prof, 'orden', profesionalObject))
      //     || (checkExistantProfessional(prof) &&
      //         datosFases.idPlanCuidadoDuracionFase === 1 &&
      //         isEqualProfesional(prof, 'idModalidadVisita') &&
      //         isEqualProfesional(prof, 'idModalidadProfesionalCobro'))
      // );

      if (!isValidDuracion()) {
        toast.error('La duración del profesional supera a la duración de la fase.');
      } else {

        setStepsData((previousData) => ({
          ...previousData,
          profesionales: editionMode ?
            previousData.profesionales.map((p) => getRowId(p) === editionRowId ? profWithId : p) :
            [...previousData.profesionales, profWithId]
        }));

        setDatosProfesionales(initialDatosProfesionales);
        setDatosFases(initialDatosFases);
        setOpenModalProfesional(false);
        setEditionMode(undefined);
      }
      // else {
      //   toast.error('Ya existe un profesional con esas características en la fase seleccionada.');
      // }
    }
  };

  const limpiarCombos = (e) => {
    const { value, name } = e.target;
    switch (name) {
      case 'idTipoProfesional': {
        setDatosProfesionales((oldData) => ({
          ...oldData,
          idTipoProfesionalEspecialidad: null,
          idFiguraProfesional: null,
          idRegistroEvolucion: null,
          idTipoCapacitacion: null
        }));

        getFiguraProfesionales({ variables: { idTipoProfesional: value } });
        getFrecuenciaProfesionales();
        break;
      }
      case 'idFiguraProfesional': {
        getFrecuenciaProfesionales();
        break;
      }
      case 'idModalidadVisita': {
        // idModalidad visita hora 4 
        setHabilitarDuracion(value != 4);

        setDatosProfesionales((oldData) => ({
          ...oldData,
          cantidadHoras: 0
        }));
      }
    }
  };

  const closeModal = () => {
    setOpenModalFase(false);
    setOpenModalProfesional(false);
    setDatosProfesionales(initialDatosProfesionales);
    setDatosFases(initialDatosFases);
    setEditionMode(undefined);
  };

  // const getOrdenes = () => {
  //   const isEqualProfesional = (objectToCheck, propToCheck, objectToCompare) => {
  //     return objectToCheck[propToCheck] === objectToCompare[propToCheck];
  //   };
  //   const sameProfesionals = stepsData?.profesionales?.filter((prof) =>
  //     stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase === prof?.idPlanCuidadoFase || fase?.idFase === prof?.idPlanCuidadoFase)?.idFase === stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase === datosProfesionales?.idPlanCuidadoFase || fase?.idFase === datosProfesionales?.idPlanCuidadoFase)?.idFase &&
  //     isEqualProfesional(prof, 'idTipoProfesional', datosProfesionales) &&
  //     isEqualProfesional(prof, 'idTipoProfesionalEspecialidad', datosProfesionales));

  //   return ordenes.filter((orden) => !sameProfesionals?.some((prof) => orden.id === prof.orden));
  // };

  const selectedFaseDuration = duracion?.find((dur) => dur.id === stepsData?.fases?.find((fase) => fase.idPlanCuidadoFase === datosProfesionales?.idPlanCuidadoFase || fase.idFase === datosProfesionales?.idPlanCuidadoFase)?.idPlanCuidadoDuracionFase)?.duration;
  return (
    <>
      <div className='plan-cuidado-step-profesionales'>

        <CustomDialog
          open={openModalFase}
          maxWidth='sm'
          fullWidth
          title={'Agregar fase'}
          onCancel={closeModal}
          onAccept={handleCrearFase}
          acceptText={!editionMode ? 'Agregar' : 'Editar'}>

          <Grid
            container
            spacing={2.5}
            className='plan-cuidado-step-profesionales'>

            <Grid size={{ xs: 11.8, md: 6 }}>
              <SelectInput
                options={fases}
                label='Fases'
                onChange={handleChangeFase}
                value={datosFases.idFase}
                name='idFase'
                margin='normal' />

            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <SelectInput
                options={duracion}
                label='Duracion'
                onChange={handleChangeFase}
                disabled={stepsData?.profesionales?.some((profesional) => profesional.idPlanCuidadoFase === datosFases?.idFase || profesional.idPlanCuidadoFase === datosFases?.idPlanCuidadoFase)}
                value={datosFases.idPlanCuidadoDuracionFase}
                name='idPlanCuidadoDuracionFase'
                margin={'normal'} />

            </Grid>
            <Grid size={{ xs: 12 }}>
              <SelectInput
                multiple={true}
                options={criterios}
                label='Criterio'
                placeHolder='Elige un criterio'
                onChange={handleChangeCriterio}
                value={datosFases.planCuidadoFaseCriterio}
                name='planCuidadoFaseCriterio'
                margin={'normal'} />

            </Grid>
          </Grid>
        </CustomDialog>

        <CustomDialog
          open={openModalProfesional}
          maxWidth='md'
          fullWidth
          title={!editionMode ? 'Agregar profesional' : 'Editar profesional'}
          onCancel={closeModal}
          onAccept={handleAdicionarProfesional}
          acceptText={!editionMode ? 'Agregar' : 'Editar'}>

          <Grid
            container
            gap={2.5}
            marginTop={0.1}
            className='plan-cuidado-step-profesionales'>

            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                disabled={true}
                options={fases}
                label='Fase'
                value={stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase == datosProfesionales?.idPlanCuidadoFase || fase?.idFase == datosProfesionales?.idPlanCuidadoFase)?.idFase} />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                disabled={true}
                options={duracion}
                label='Duracion de fase'
                value={stepsData?.fases?.find((fase) => fase?.idPlanCuidadoFase == datosProfesionales?.idPlanCuidadoFase || fase?.idFase == datosProfesionales?.idPlanCuidadoFase)?.idPlanCuidadoDuracionFase} />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={tipoProfesionales}
                label='Tipo de Profesional'
                onChange={handleChange}
                value={datosProfesionales?.idTipoProfesional}
                name='idTipoProfesional' />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={figuraProfesionales}
                label='Responsabilidad'
                onChange={handleChange}
                value={datosProfesionales?.idFiguraProfesional}
                name='idFiguraProfesional' />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={modalidadVisitas}
                label='Modo'
                onChange={handleChange}
                value={datosProfesionales?.idModalidadVisita}
                name='idModalidadVisita' />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={frecuenciaProfesionales}
                label='Frecuencia'
                onChange={handleChange}
                value={datosProfesionales?.idFrecuenciaProfesional}
                name='idFrecuenciaProfesional' />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={ordenes}
                label='Orden'
                onChange={handleChange}
                value={datosProfesionales?.orden}
                name='orden' />

            </Grid>
            <Grid size={{ xs: 5.8 }}>
              <SelectInput
                options={
                  selectedFaseDuration == 0 ?
                    duracion?.filter((d) => d.duration == 0) :
                    duracion?.filter((d) => d.duration <= selectedFaseDuration && d.duration > 0)
                }
                label='F. Duracion'
                onChange={handleChange}
                value={selectedFaseDuration == 0 ?
                  duracion?.find((d) => d.duration == 0).id : datosProfesionales?.duracion}
                name='duracion' />

            </Grid>
            <Grid size={{ xs: 9.4 }}>
              <SelectInput
                options={modalidadProfesionalCobro}
                label='Modalidad de visita'
                onChange={handleChange}
                value={datosProfesionales?.idModalidadProfesionalCobro}
                name='idModalidadProfesionalCobro' />

            </Grid>
          </Grid>
        </CustomDialog>

        {
          stepsData?.fases?.length == 0 &&
          <div className='step-profesionales'>
            <div className='empty-grid'>
              <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
              <p>No se ha agregado ninguna fase</p>
              <CustomButton
                variant={'contained'}
                onClick={() => setOpenModalFase(true)}
                size={'small'}>

                Agregar Fase
              </CustomButton>
            </div>
          </div>
        }
        {stepsData?.fases?.sort((a, b) => a.idFase - b.idFase).map((fase) => {
          const faseProfesionals = stepsData?.profesionales?.filter((profesional) => profesional.idPlanCuidadoFase === fase?.idFase || profesional.idPlanCuidadoFase === fase?.idPlanCuidadoFase);
          const faseName = fases?.find((f) => f.id === fase?.idFase)?.displayName;
          const duration = duracion?.find((d) => d.id === fase?.idPlanCuidadoDuracionFase)?.displayName;
          return (
            <>
              <Card className='fase-detail-container' elevation={0}>
                <Grid
                  container
                  gap={2}
                  justifyContent={'space-between'}>

                  <Grid className='fase-detail-label' size={{ xs: 3.2 }}>
                    Fase: <p className='label-bold'>{faseName}</p> <p className='label-divider'>|</p>
                    Duración: <p className='label-bold'>{duration}</p>
                    <PopoverModal>
                      <div className='popover-modal-content'>
                        <div className='item-option clickable-option'
                          onClick={() => {
                            setDatosFases(fase);
                            setOpenModalFase(true);
                            setEditionMode(fase);
                          }} aria-hidden='true'>

                          <EditIcon className='edit-icon' />
                          <span className='toggle-action'>Editar</span>
                        </div>
                        <div className='item-option clickable-option'
                          aria-hidden='true'
                          onClick={() => {
                            setStepsData((previousData) => ({
                              ...previousData,
                              profesionales: [
                                ...(previousData.profesionales || []).filter((obj) =>
                                  obj.idPlanCuidadoFase !== fase?.idPlanCuidadoFase && obj.idPlanCuidadoFase !== fase?.idFase
                                )]

                            }));
                            setStepsData((previousData) => ({
                              ...previousData,
                              fases: [
                                ...(previousData.fases || []).filter((obj) =>
                                  obj.idFase !== fase.idFase
                                )]

                            }));
                          }}>

                          <DeleteIcon className='edit-icon' />
                          <span className='toggle-action'>Eliminar</span>
                        </div>
                      </div>
                    </PopoverModal>
                  </Grid>
                  {
                    faseProfesionals.length > 0 &&
                    <Grid className='profesional-creation-button' size={{ xs: 2.3 }}>
                      <CustomButton
                        className={'custom-button-profesionales'}
                        variant={'contained'}
                        onClick={() => {
                          setDatosProfesionales((previousData) => ({ ...previousData, idPlanCuidadoFase: fase?.idPlanCuidadoFase }));
                          setDatosFases(fase);
                          setOpenModalProfesional(true);
                        }}
                        size={'small'}>

                        Agregar profesional
                      </CustomButton>
                    </Grid>
                  }
                </Grid>
                {
                  faseProfesionals.length > 0 ?
                    <DataGridGenerico
                      columns={columns}
                      rows={faseProfesionals.map((p) => {
                        const withId = ensureRowId(p);
                        return { ...withId, id: getRowId(withId) };
                      })}
                      toolbar={false}
                    /> :


                    <div className='step-profesionales'>
                      <div className='empty-grid'>
                        <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
                        <p>No se ha agregado ningun profesional</p>
                        <CustomButton
                          variant={'contained'}
                          onClick={() => {
                            setDatosProfesionales((previousData) => ({ ...previousData, idFase: fase?.idFase, idPlanCuidadoFase: fase?.idPlanCuidadoFase }));
                            setDatosFases(fase);
                            setOpenModalProfesional(true);
                          }
                          }
                          size={'small'}>

                          Agregar Profesional
                        </CustomButton>
                      </div>
                    </div>
                }
                {fase?.planCuidadoFaseCriterio?.length > 0 &&
                  <TextField
                    label='Criterios de la fase'
                    fullWidth
                    variant='outlined'
                    className='chip-input'
                    disabled
                    InputProps={{
                      startAdornment: fase?.planCuidadoFaseCriterio?.map((criterio, index) => {
                        const chipLabel = criterios?.find((c) => c.id === criterio)?.displayName;
                        return (
                          <Chip
                            key={index}
                            label={chipLabel}
                            onDelete={
                              fase?.planCuidadoFaseCriterio?.length !== 1 ?
                                () => {
                                  setStepsData((previousData) => ({
                                    ...previousData,
                                    fases: [
                                      ...(previousData.fases || []).filter((f) => f?.idFase !== fase?.idFase),
                                      { ...fase, planCuidadoFaseCriterio: fase?.planCuidadoFaseCriterio?.filter((c) => c !== criterio) }]

                                  }));
                                } :
                                null
                            }
                            className='fase-chip' />);


                      })
                    }} />

                }
              </Card>
            </>);

        })
        }
        {
          stepsData?.fases?.length > 0 &&
          <div className="fase-creation-button">
            <CustomButton
              variant={'contained'}
              onClick={() => setOpenModalFase(true)}
              size={'small'}>

              Agregar Fase
            </CustomButton>
          </div>
        }
      </div>

    </>);

};
const opcionesDuracion = [
  { id: 1, displayName: 'Normal', name: 'Normal' },
  { id: 2, displayName: 'Extendida', name: 'Extendida' }];


export default StepProfesionales;